module.exports = __webpack_public_path__ + "media/3d-GIS-1.be3a4a15.mp4";